import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

import "./AnimatedBorder.css";

interface AnimatedBorderProps {
  children: React.ReactNode;
  className?: string;
  roundedClassName?: string;
}

export default function AnimatedBorder({
  children,
  className,
  roundedClassName = "rounded-2xl",
}: AnimatedBorderProps) {
  return (
    <div className={twMerge("re-animated-border", roundedClassName, className)}>
      <div className={twMerge("relative z-10 bg-white", roundedClassName)}>
        {children}
      </div>
    </div>
  );
}
